import type { ReactNode } from 'react';

import { HeroTour3d } from './HeroTour3d';

type GalleryMediaActionsProps = {
  videoAction?: ReactNode;
  tour3dUrl?: string;
  addressLabel: string | null;
};

export const GalleryMediaActions = ({
  videoAction,
  tour3dUrl,
  addressLabel,
}: GalleryMediaActionsProps) => {
  if (!videoAction && !tour3dUrl) return null;

  return (
    <div
      role="group"
      aria-label="Media actions"
      className="gallery-media-actions"
      data-grouped={Boolean(videoAction && tour3dUrl)}
      data-pv="mediaActions"
    >
      {tour3dUrl && (
        <HeroTour3d tourUrl={tour3dUrl} addressLabel={addressLabel} trigger="gallery-pill" />
      )}
      {videoAction}
    </div>
  );
};
